import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import { ReactNode } from 'react';
import { AccordionChip } from './AccordionChip';

type Props = {
  icon: ReactNode;
  title: ReactNode;
  subtitle: ReactNode | null;
  details: ReactNode;
  isConfigured: boolean;
  isLoading: boolean;
  isExpanded: boolean;
  onClick: (event: React.SyntheticEvent, newExpanded: boolean) => void;
};

export const ACCORDION_STYLES = {
  backgroundImage: 'linear-gradient(219.91deg, rgba(38, 132, 255, 0.1) -13.01%, rgba(255, 255, 255, 0) 77.22%)',
};

export const IntegrationAccordion = (props: Props) => {
  const { isConfigured, icon, title, subtitle, details, onClick, isLoading, isExpanded } = props;

  return (
    <Accordion onChange={onClick} expanded={isExpanded}>
      <AccordionSummary
        sx={{
          '&:hover': {
            transition: 'background-color 150ms',
            backgroundColor: 'backdrops.lightGrey',
          },
        }}
        expandIcon={details ? <ExpandMore /> : <ChevronRight />}
        id={`${title?.toString()}-header`}
        aria-controls={`${title?.toString()}-content`}
      >
        <Stack sx={{ p: 1 }} gap={2}>
          <Stack
            direction="row"
            alignItems="center"
            gap={2}
            sx={{
              minHeight: '32px',
            }}
          >
            {icon}
            <Typography fontWeight="bold">{title}</Typography>
            {!isLoading && <AccordionChip isConfigured={isConfigured} />}
          </Stack>
          {subtitle && <Typography fontSize="0.875rem">{subtitle}</Typography>}
        </Stack>
      </AccordionSummary>

      <AccordionDetails sx={{ padding: 0 }}>{details}</AccordionDetails>
    </Accordion>
  );
};
